<template>
    <!--<ion-item-sliding>-->
    <ion-item class="message"
              :class="{retracted: message.is_retracted, outbox: isOutbox, inbox: isInbox}">
        <ion-avatar slot="start"
                    v-show="! $root.isMobileOrSmall">
            <img
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+"
                alt=""/>
        </ion-avatar>
        <ion-label>
            <ion-item @click="openMessage(message.id)"
                      lines="none"
                      :button="!$root.isMobileOrSmall">
                <ion-label>
                    <h2 v-if="isOutbox">
                        <span>{{ $t('ncrypt.write_message.recipient_to_label') }}: </span>

                        <span v-for="(recipient, i) in message.recipients"
                              v-bind:key="`${i}-${recipient.id}`"
                              outline
                              color="primary">
                            {{ recipient.display_name }}
                        </span>
                    </h2>

                    <h2 v-else>
                        {{ message.sender.display_name }}
                    </h2>

                    <h3>{{ message.subject }}</h3>
                </ion-label>

                <ion-badge slot="end"
                           :color="message.is_retracted ? 'danger' : 'primary'">
                    {{ message.sent_at_short }}
                </ion-badge>
            </ion-item>

            <ion-item v-show="!$root.isMobileOrSmall"
                      lines="none"
                      v-if="!message.is_retracted && message.attachments && message.attachments.length"
                      class="ion-wrap ion-text-wrap"
                      no-margin>
                <attachment v-for="(attachment, i) in message.attachments"
                            v-bind:key="`${i}-${attachment.id}`"
                            :attachment="attachment"
                            outline
                            color="primary"></attachment>
            </ion-item>
        </ion-label>
    </ion-item>
</template>

<script>
    import Attachment from "../../Attachment";
    import {MessageBoxType} from "../../../const/MessageBoxType";

    export default {
        components: {Attachment},
        name: "ListMessage",
        props: {
            message: {type: Object},
            type: {type: String},
        },
        methods: {
            openMessage(id) {
                this.$router.push({name: 'message', params: {id}, query: {boxType: this.type}});
            },
        },
        computed: {
            isOutbox() {
                return this.type === MessageBoxType.OUTBOX;
            },
            isInbox() {
                return this.type === MessageBoxType.INBOX;
            },
        },
        created() {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .message.retracted {
        h2 {
            color: #cc2e24;
        }
    }

    ion-label {
        h1, h2, h3, h4 {
            text-overflow: inherit;
            overflow: inherit;
        }
    }
</style>
